// Phase D — Pure helpers for the "Paste address → Maps link" component.
// Extracted to a sibling so unit tests don't need to import the JSX (which
// drags in Radix popover + shadcn imports through the `@/` alias that
// jest in this repo doesn't resolve).

/**
 * Compose the Google Maps search URL for a free-form address.
 *
 * Uses Google's own "search" endpoint which handles fuzzy queries natively
 * — no Geocoding API call needed.
 */
export function buildMapsSearchUrl(address) {
  const q = (address || "").trim();
  if (!q) return "";
  return `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(q)}`;
}

/**
 * Insert `snippet` into `original` at offsets [selStart, selEnd], padding
 * with single spaces on either side so the snippet never fuses to existing
 * text. Returns { next, caret } where `next` is the new string and `caret`
 * is where to drop the cursor afterwards.
 */
export function insertAtCaret(original, selStart, selEnd, snippet) {
  const left = original.slice(0, selStart);
  const right = original.slice(selEnd);
  const padLeft = left && !/\s$/.test(left) ? " " : "";
  const padRight = right && !/^\s/.test(right) ? " " : "";
  const insertion = `${padLeft}${snippet}${padRight}`;
  const next = `${left}${insertion}${right}`;
  const caret = (left + insertion).length;
  return { next, caret };
}
